export enum RiskAssesmentPrivacyStatuses
    {
        Open = 1,
        Confidential = 2
    }
